'use strict';

var _typeof = require("/source/phone-lead-client/node_modules/@babel/runtime/helpers/typeof");

var has = require('has');

var hasUnscopables = typeof Symbol === 'function' && _typeof(Symbol.unscopables) === 'symbol';
var map = hasUnscopables && Array.prototype[Symbol.unscopables];
var $TypeError = TypeError;

module.exports = function shimUnscopables(method) {
  if (typeof method !== 'string' || !method) {
    throw new $TypeError('method must be a non-empty string');
  }

  if (!has(Array.prototype, method)) {
    throw new $TypeError('method must be on Array.prototype');
  }

  if (hasUnscopables) {
    map[method] = true;
  }
};